import { Action } from './base'
import API from 'app/services/driverActiveness/driverActivenessApi'

export enum DriverActivenessActionTypeKeys {
  SET_EXPORTED = 'SET_EXPORTED',
}

export type SetExportedAction = Action<
  typeof DriverActivenessActionTypeKeys.SET_EXPORTED,
  any
>

export const setExported = async (): Promise<any> => {
  const api = API.create()
  try {
    const response = await api.setExported()
    return true
  } catch (error) {
    return { error: error.status.data.code }
  }
}

export type DriverActivenessActions = SetExportedAction
